import { render, staticRenderFns } from "./ToggleFreeInputMethodSelector.vue?vue&type=template&id=15b1c602&scoped=true&"
import script from "./ToggleFreeInputMethodSelector.vue?vue&type=script&lang=ts&"
export * from "./ToggleFreeInputMethodSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b1c602",
  null
  
)

export default component.exports